import { styled } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreIconButton } from '@components/CoreIconButton';
import { CoreBox } from '@youscience/core';

export const StyledContentCounselor = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  padding: '1rem',
  flex: 'initial',
  gap: '1rem',
  borderRadius: '0.75rem',
  border: `1px solid ${theme.palette.divider}`,
  justifyContent: 'space-between',

  [theme.breakpoints.down('sm')]: {
    alignSelf: 'stretch',
    flex: 'auto',
  },

  [theme.breakpoints.up('sm')]: {
    width: '24.125rem',
  },
}));

export const StyledContentCounselorDescription = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  minWidth: '9.125rem',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  gap: '0.5rem',

  [theme.breakpoints.down('sm')]: {
    alignSelf: 'flex-start',
    flex: 'auto',
  },

  [theme.breakpoints.up('sm')]: {},
}));

export const StyledContentCounselorDescriptionStatus = styled(CoreIconButton)(({ theme }) => ({
  height: '1.25rem',
  padding: '0.25rem',
  background: theme.palette.common.white,

  '&:hover': {
    color: coreThemeColors.secondary.main,
    background: theme.palette.common.white,
    boxShadow: 'none',
  },
  '& > svg:first-of-type': {
    fill: coreThemeColors.secondary.main,
  },
}));

export const StyledContentCounselorDescriptionText = styled(CoreBox)(() => ({
  flex: 'initial',
  gap: '4px',
}));
